module.exports = __webpack_public_path__ + "static/media/justin_alert.58cb6672.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/justin_alert.png
// module id = 1073
// module chunks = 0